import Bowser from 'bowser';
const browser = Bowser.getParser(window.navigator.userAgent);

/**
 * A list of supported browsers that should be displayed in any UI informing
 * the user of what they can use
 *
 * @type {{}}
 */
export const DISPLAY_SUPPORTED_BROWSERS = {
  chrome: '>0',
  firefox: '>0',
  edge: '>0',
  safari: '>0',
  samsung_internet: '>0'
};

export const READABLE_SUPPORTED_BROWSERS = Object.keys(
  DISPLAY_SUPPORTED_BROWSERS
).map((str) => str.replace('_', ' '));

/**
 * A list of supported browsers that should be used for validBrowser logic but
 * are not required to be shown to a user
 *
 * @type {*}
 */
export const HIDDEN_SUPPORTED_BROWSERS = {
  chromium: '>0',
  googlebot: '>0',
  opera: '>0',
  android: '>0',
  electron: '>0'
};

/**
 * Returns true if the active browser is supported by the novated applications.
 * A list of available aliases can be found at {@link https://github.com/lancedikson/bowser/blob/master/src/constants.js}
 *
 * @returns {boolean}
 */
export default function isBrowserValid() {
  return Boolean(
    browser.satisfies({
      ...DISPLAY_SUPPORTED_BROWSERS,
      ...HIDDEN_SUPPORTED_BROWSERS
    })
  );
}
